import axios, { AxiosRequestConfig, AxiosInstance, AxiosResponse } from 'axios'
import store from '../store'
import MasterConfig from '../models/config/masterConfig'
import { OpenIdConnectInterceptors } from 'inuits-vuejs-oidc'

export default class BaseApiRepository {
  private axiosInstance: AxiosInstance

  constructor () {
    const config: MasterConfig = store.state.config.config

    this.axiosInstance = axios.create({
      baseURL: config.api.baseUrl + config.api.apiSuffix
    })

    // Add oidc interceptors
    if (config.oidc && config.oidc.baseUrl && config.oidc.clientId) {
      this.axiosInstance.interceptors.request.use(
        OpenIdConnectInterceptors.buildRequestTokenInterceptorCallback(store)
      )

      this.axiosInstance.interceptors.response.use(
        function (response) { return response },
        error => OpenIdConnectInterceptors.buildResponseErrorInterceptorCallback(error, store)
      )

    }

  }

  protected get (endpoint: string, config: AxiosRequestConfig = {}): Promise<any> {
    return this.axiosInstance.get(endpoint, config).then(function (result: AxiosResponse) {
      // Only return the data of response
      return result.data
    })
  }

  protected post (endpoint: string, data: any, config: AxiosRequestConfig = {}): Promise<any> {
    return this.axiosInstance.post(endpoint, data, config).then(function (result: AxiosResponse) {
      // Only return the data of response
      return result.data
    })
  }
}
